export const immediateEventBySpeciality = {
  MEDICO: 'Pac_Home_MedImediato',
  ENFERMEIRO: '',
  DENTISTA: '',
  FISIOTERAPEUTA: '',
  FONOAUDIOLOGO: '',
  NUTRICIONISTA: '',
  ASSISTENTE_SOCIAL: '',
  PSICOLOGO: '',
}

export const scheduledEventBySpeciality = {
  MEDICO: 'Pac_Home_MedAgendado',
  ENFERMEIRO: '',
  DENTISTA: '',
  FISIOTERAPEUTA: '',
  FONOAUDIOLOGO: 'Pac_Home_FonAgendado',
  NUTRICIONISTA: 'Pac_Home_NutAgendado',
  ASSISTENTE_SOCIAL: '',
  EDUCADOR_FISICO: 'Pac_HomeCNX_CardEduFisico_ConsultaAgendada',
}
